.divider {
  border-width: 2px;
  border-color: var(--tuna-palette-primary-main);
}
